import { useCustomReducer } from '../../../../../base/customHooks'
import IPButton from '../../../../../components/IPButton'
import { useMemo, useState } from 'react'
import '../../AccountSummary/AccountSummary.scss'
import Swal from 'sweetalert2'
import InputCampaign from '../../../../../components/InputCampaign'
import { exportToXLSXVDFMultipleColumns } from '../../../../../base/utils/dataHelper'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../../base/customHooks/componentHOC'
import IPExcelButton from '../../../../../components/IPExcelButton'
import Table from '../../../../../components/Table'
import { GetVodafoneOrderRequest, GetVodafoneOrderResponse } from '../models/model'
import { GetOrdersApi } from '../services/getOrdersApi'
import moment from 'moment'

interface IVodafoneOrdersByIMEIState {
  orderStartDate?: string
  orderEndDate?: string
  siparisNo?: string
  belgeStartDate?: string
  belgeEndDate?: string
  faturaNo?: string
  malzemeNo?: string
  marka?: string
  model?: string
  imei?: string
  ean?: string
  vdf?: string
}

function VodafoneOrdersByIMEI(props: BaseComponentWithContextProps) {
  const getInitialState = (): IVodafoneOrdersByIMEIState => {
    return {
      orderStartDate: undefined,
      orderEndDate: undefined,
      siparisNo: undefined,
      belgeStartDate: undefined,
      belgeEndDate: undefined,
      faturaNo: undefined,
      malzemeNo: undefined,
      marka: undefined,
      model: undefined,
      imei: undefined,
      ean: undefined,
      vdf: undefined,
    }
  }

  const intialState = getInitialState()
  const [state, setState] = useCustomReducer<IVodafoneOrdersByIMEIState>(intialState)
  const [ordersData, setOrdersData] = useState<GetVodafoneOrderResponse[]>([])
  const [currentPage, setCurrentPage] = useState(0)

  const getOrdersList = async () => {
    const req: GetVodafoneOrderRequest = {
      OrderStartDate: state.orderStartDate?.trim() ?? '',
      OrderEndDate: state.orderEndDate?.trim() ?? '',
      SiparisNo: state.siparisNo?.trim() ?? '',
      BelgeStartDate: state.belgeStartDate?.trim() ?? '',
      BelgeEndDate: state.belgeEndDate?.trim() ?? '',
      FaturaNo: state.faturaNo?.trim() ?? '',
      MalzemeNo: state.malzemeNo?.trim() ?? '',
      Marka: state.marka?.trim() ?? '',
      Model: state.model?.trim() ?? '',
      IMEI: state.imei?.trim() ?? '',
      EAN: state.ean?.trim() ?? '',
      VDF: state.vdf?.trim() ?? '',
    }

    props.showLoading()
    const api: GetOrdersApi = new GetOrdersApi({})

    api
      .getSummaryList(req)
      .then(result => {
        if (result) {
          setOrdersData(result)
          if (result.length === 0) {
            Swal.fire({
              icon: 'warning',
              title: 'Sipariş verisi bulunamadı',
              showConfirmButton: true,
              allowOutsideClick: false,
            })
          }
          props.hideLoading()
        } else {
          props.hideLoading()
        }
      })
      .catch((err: any) => {
        props.hideLoading()
        Swal.fire({
          icon: 'error',
          title: err?.description ?? 'Sipariş verisi alınırken hata oluştu.',
          showConfirmButton: true,
          allowOutsideClick: false,
        })
      })
  }

  const columnDefinitions = [
    { Header: 'Sipariş Tarihi', accessor: 'siparisTarihi' },
    { Header: 'Sipariş No', accessor: 'siparisNo' },
    { Header: 'Fatura Tarihi', accessor: 'faturaTarihi' },
    { Header: 'Fatura No', accessor: 'faturaNo' },
    { Header: 'Malzeme Kodu', accessor: 'malzemeKodu' },
    { Header: 'Malzeme Adı', accessor: 'malzemeAdi' },
    { Header: 'Marka', accessor: 'marka' },
    { Header: 'Model', accessor: 'model' },
    { Header: 'IMEI', accessor: 'imei' },
    { Header: 'EAN', accessor: 'ean' },
    { Header: 'Handset Kod', accessor: 'handsetKod' },
    { Header: 'Birim Fiyat', accessor: 'birimFiyat' },
    { Header: 'Sipariş Tutarı', accessor: 'siparisTutari' },
    { Header: 'KDV', accessor: 'kdv' },
  ]

  const tableColumns = useMemo(() => columnDefinitions, [])

  const tableData = useMemo(() => {
    return ordersData.map((item) => {
      const formatNumber = (value: any) => {
        if (!value) return ''
        const numValue = parseFloat(value.toString().replace(',', '.'))
        return isNaN(numValue) ? '' : numValue.toFixed(2).replace('.', ',')
      }

      return {
        siparisTarihi: item.SiparisTarihi ? moment(item.SiparisTarihi).format('DD.MM.YYYY') : '',
        siparisNo: item.SiparisNo,
        faturaTarihi: item.FaturaTarihi ? moment(item.FaturaTarihi).format('DD.MM.YYYY') : '',
        faturaNo: item.FaturaNo,
        malzemeKodu: item.MalzemeKodu,
        malzemeAdi: item.MalzemeAdi,
        marka: item.Marka,
        model: item.Model,
        imei: item.IMEI,
        ean: item.EAN,
        handsetKod: item.HandsetKod,
        birimFiyat: <div style={{ textAlign: 'right' }}>{formatNumber(item.BirimFiyat)}</div>,
        siparisTutari: <div style={{ textAlign: 'right' }}>{formatNumber(item.SiparisTutari)}</div>,
        kdv: <div style={{ textAlign: 'right' }}>{formatNumber(item.KDV)}</div>,
      }
    })
  }, [ordersData])

  const excelButton = async () => {
    try {
      if (!ordersData || ordersData.length === 0) {
        return Swal.fire({
          icon: 'error',
          title: 'Excele atılacak veri bulunmamaktadır.',
          allowOutsideClick: true,
          backdrop: true,
        })
      }

      const formatNumber = (value: any) => {
        if (!value) return ''
        const numValue = parseFloat(value.toString().replace(',', '.'))
        return isNaN(numValue) ? '' : numValue.toFixed(2).replace('.', ',')
      }

      const data: any[] = ordersData.map(item => ({
        'SİPARİŞ TARİHİ': item.SiparisTarihi ? moment(item.SiparisTarihi).format('DD.MM.YYYY') : '',
        'SİPARİŞ NO': item.SiparisNo,
        'FATURA TARİHİ': item.FaturaTarihi ? moment(item.FaturaTarihi).format('DD.MM.YYYY') : '',
        'FATURA NO': item.FaturaNo,
        'MALZEME KODU': item.MalzemeKodu,
        'MALZEME ADI': item.MalzemeAdi,
        'MARKA': item.Marka,
        'MODEL': item.Model,
        'IMEI': item.IMEI,
        'EAN': item.EAN,
        'HANDSET KOD': item.HandsetKod,
        'BİRİM FİYAT': formatNumber(item.BirimFiyat),
        'SİPARİŞ TUTARI': formatNumber(item.SiparisTutari),
        'KDV': formatNumber(item.KDV),
      }))

      exportToXLSXVDFMultipleColumns(data, 'Vodafone Siparişleri', 'L,M,N')
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err?.description ?? 'Excel aktarımında hata oluştu.',
        allowOutsideClick: true,
        backdrop: true,
      })
    }
  }

  return (
    <div className='Reports'>
      <div className='heading-text d-flex justify-content-between align-items-center'>
        <h4 style={{ textAlign: 'center' }}>Vodafone Siparişleri</h4>
        <div className='d-flex align-items-center'>
          <IPExcelButton onClick={excelButton} />
        </div>
      </div>

      <form>
        <div className='form-row' style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='date'
              id='OrderStartDate'
              name='OrderStartDate'
              label='Sipariş Başlangıç'
              value={state.orderStartDate}
              onChange={e => setState({ orderStartDate: e.target.value })}
              isActive
            />
          </div>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='date'
              id='OrderEndDate'
              name='OrderEndDate'
              label='Sipariş Bitiş'
              value={state.orderEndDate}
              onChange={e => setState({ orderEndDate: e.target.value })}
              isActive
            />
          </div>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='text'
              id='SiparisNo'
              name='SiparisNo'
              label='Sipariş No'
              value={state.siparisNo}
              onChange={e => setState({ siparisNo: e.target.value })}
              isActive
            />
          </div>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='date'
              id='BelgeStartDate'
              name='BelgeStartDate'
              label='Belge Başlangıç'
              value={state.belgeStartDate}
              onChange={e => setState({ belgeStartDate: e.target.value })}
              isActive
            />
          </div>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='date'
              id='BelgeEndDate'
              name='BelgeEndDate'
              label='Belge Bitiş'
              value={state.belgeEndDate}
              onChange={e => setState({ belgeEndDate: e.target.value })}
              isActive
            />
          </div>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='text'
              id='FaturaNo'
              name='FaturaNo'
              label='Fatura No'
              value={state.faturaNo}
              onChange={e => setState({ faturaNo: e.target.value })}
              isActive
            />
          </div>
        </div>

        <div className='form-row' style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='text'
              id='MalzemeNo'
              name='MalzemeNo'
              label='Malzeme No'
              value={state.malzemeNo}
              onChange={e => setState({ malzemeNo: e.target.value })}
              isActive
            />
          </div>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='text'
              id='Marka'
              name='Marka'
              label='Marka'
              value={state.marka}
              onChange={e => setState({ marka: e.target.value })}
              isActive
            />
          </div>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='text'
              id='Model'
              name='Model'
              label='Model'
              value={state.model}
              onChange={e => setState({ model: e.target.value })}
              isActive
            />
          </div>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='text'
              id='IMEI'
              name='IMEI'
              label='IMEI'
              value={state.imei}
              onChange={e => setState({ imei: e.target.value })}
              isActive
            />
          </div>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='text'
              id='EAN'
              name='EAN'
              label='EAN'
              value={state.ean}
              onChange={e => setState({ ean: e.target.value })}
              isActive
            />
          </div>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='text'
              id='VDF'
              name='VDF'
              label='VDF'
              value={state.vdf}
              onChange={e => setState({ vdf: e.target.value })}
              isActive
            />
          </div>
        </div>

        <div className='form-row' style={{ display: 'flex', justifyContent: 'center' }}>
          <div className='form-group col-md-3' style={{ justifyContent: 'center', display: 'flex' }}>
            <IPButton
              text='Listele'
              className='button'
              onClick={() => getOrdersList()}
              style={{
                backgroundColor: 'red',
                color: 'white',
                borderRadius: '10px',
                width: '150px',
                height: '50px',
              }}
            />
          </div>
        </div>
      </form>

      <div className='m-4'>
        <Table
          columns={tableColumns}
          data={tableData}
          currentPage={currentPage}
          onPageChange={setCurrentPage}
          columnCount={14}
          backgroundColor='red'
          color='white'
        />
      </div>
    </div>
  )
}

export default componentWithContext(VodafoneOrdersByIMEI)
